import { useInfiniteQuery } from '@tanstack/react-query'
import { requestServices } from '../requestServices'
import { GetRequestsParams } from '../requestTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseGetRequestsParams extends Omit<GetRequestsParams, 'page_id'> {
  enabled?: boolean
}

export const useGetRequests = (params: UseGetRequestsParams = {}) => {
  const { enabled = true, ...queryParams } = params

  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.PAYMENT_REQUESTS_HISTORY, queryParams],
    initialPageParam: 0, // Same as React Native
    queryFn: async ({ pageParam = 0 }) => {
      const response = await requestServices.getRequests({
        ...queryParams,
        page_id: pageParam,
        page_size: queryParams.page_size || 8,
      })

      return {
        requests: response.requests,
        next_page_id: response.next_page_id,
      }
    },
    getNextPageParam: (lastPage) => {
      return lastPage.next_page_id || undefined
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  })
}
